export const COS_OBJECT_TYPES = Object.freeze({
  CONTENT: 'CONTENT',
  EXTENSION_RESOURCE: 'EXTENSION_RESOURCE',
  LAYOUT: 'LAYOUT',
  CUSTOM_WIDGET: 'CUSTOM_WIDGET',
  WIDGET: 'WIDGET',
  FORM: 'FORM',
  PLACEMENT: 'PLACEMENT',
  IMAGE: 'IMAGE',
  DOMAIN_SETTINGS: 'DOMAIN_SETTINGS',
  SITE_SETTINGS: 'SITE_SETTINGS',
  EMAIL_ADDRESS: 'EMAIL_ADDRESS',
  WORKFLOW: 'WORKFLOW',
  HUBDB_TABLE: 'HUBDB_TABLE',
  REDIRECT_URL: 'REDIRECT_URL',
  DESIGN_FOLDER: 'DESIGN_FOLDER',
  SITE_MAP: 'SITE_MAP',
  DOMAIN: 'DOMAIN',
  BLOG: 'BLOG',
  FILE: 'FILE',
  FOLDER: 'FOLDER',
  SITE_MENU: 'SITE_MENU',
  THEME: 'THEME',
  CONTENT_GROUP: 'CONTENT_GROUP',
  FOLLOW_ME: 'FOLLOW_ME',
  KNOWLEDGE_BASE: 'KNOWLEDGE_BASE',
  LIST_MEMBERSHIP: 'LIST_MEMBERSHIP',
  CONTACT_MEMBERSHIP: 'CONTACT_MEMBERSHIP',
  PASSWORD_PROTECTED: 'PASSWORD_PROTECTED',
  UNRESTRICTED_ACCESS: 'UNRESTRICTED_ACCESS',
  MARKETPLACE_LISTING: 'MARKETPLACE_LISTING',
  LAYOUT_SECTION: 'LAYOUT_SECTION',
  THEME_SETTINGS: 'THEME_SETTINGS',
  VIDEO_PLAYER: 'VIDEO_PLAYER',
  URL_MAPPING: 'URL_MAPPING',
  KNOWLEDGE_CATEGORY: 'KNOWLEDGE_CATEGORY',
  KNOWLEDGE_HOMEPAGE_CATEGORY: 'KNOWLEDGE_HOMEPAGE_CATEGORY',
  RAW_ASSET: 'RAW_ASSET',
  GLOBAL_CONTENT: 'GLOBAL_CONTENT',
  HUBDB_TABLE_ROW: 'HUBDB_TABLE_ROW',
  BLOG_AUTHOR: 'BLOG_AUTHOR',
  SERVERLESS_FUNCTION: 'SERVERLESS_FUNCTION',
  KNOWLEDGE_CATEGORY_TRANSLATION: 'KNOWLEDGE_CATEGORY_TRANSLATION',
  TAG: 'TAG',
  SECTION: 'SECTION',
  CRM_OBJECT_TYPE: 'CRM_OBJECT_TYPE',
  PERSONALIZATION_TOKEN: 'PERSONALIZATION_TOKEN',
  QUOTE_TEMPLATE: 'QUOTE_TEMPLATE',
  BRAND_BUSINESS_UNIT: 'BRAND_BUSINESS_UNIT',
  CRM_OBJECT: 'CRM_OBJECT',
  DATA_QUERY: 'DATA_QUERY',
  CUSTOMER_PORTAL: 'CUSTOMER_PORTAL',
  PROJECT: 'PROJECT',
  PAYMENT: 'PAYMENT',
  BRAND_SETTINGS: 'BRAND_SETTINGS'
});